<script setup lang="ts">
import type { IDashboardWidgetProps, TWidgetEmits } from '@tenorlab/vue-dashboard'
import { DashboardWidgetBase, WrapperColumnContent, useWidgetEmits } from '@tenorlab/vue-dashboard'

const props = defineProps<IDashboardWidgetProps>()
const emits = defineEmits<TWidgetEmits>()
const emitHandlers = useWidgetEmits(emits)

const style: any = {
  width: '100%',
  display: 'flex',
  flexDirection: 'column',
  lineHeight: '1.25rem',
  textAlign: 'right',
}
</script>

<template>
  <DashboardWidgetBase v-bind="props" v-on="emitHandlers">
    <WrapperColumnContent>
      <div :style="{ ...style, lineHeight: '2.25rem' }">
        <div class="text-sm">Limit:</div>
        <div class="dashboard-number number-xl text-primary">$50,000</div>
      </div>
      <div :style="{ marginTop: '0.5rem' }"></div>
      <div :style="style">
        <div class="text-sm">Available:</div>
        <div class="dashboard-number number-base text-primary">$4,150</div>
      </div>
      <div :style="style">
        <div class="text-sm">Terms:</div>
        <div class="dashboard-number number-base text-primary">NET 30</div>
      </div>
    </WrapperColumnContent>
  </DashboardWidgetBase>
</template>
